import { useDispatch } from 'react-redux';
import { clearSuggestions } from '@client/catalog/redux/suggestions/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export function useClearSuggestionsAction(): typeof clearSuggestions {
  const dispatch = useDispatch();
  return bindActionCreators(clearSuggestions, dispatch);
}
